const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.getBaseInfo()
        },
        getBaseInfo() {
            this.$request.post(`/transformToAfter/app/bid/document/zbFileInfo`, {
                bdGuid: this.form.bdGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '公告名称': res.data.ggName,
                    '项目名称': res.data.gcName,
                    '标段名称': res.data.bdName,
                    '标段编号': res.data.bdBH,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
